import { styled } from "styled-components";
import { useTestimonials } from "../hooks/useTestimonials";
import TestimonialSection from "../components/common/TestimonialSection";
import PartnersContainer from "../components/common/PartnersContainer";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
`;

const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 60px 60px;
  width: 100%;
  min-height: calc(100vh - 72px);
  box-sizing: border-box;

  @media (max-width: 1023px) {
    padding: 30px 40px;
    min-height: calc(100vh - 64px);
  }

  @media (max-width: 767px) {
    padding: 20px;
    min-height: calc(100vh - 56px);
  }
`;

const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 50px;
  width: 100%;
  max-width: 1608px;

  @media (max-width: 1023px) {
    flex-direction: column;
  }
`;

const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  flex: 1;
  min-width: 0;

  @media (max-width: 1023px) {
    gap: 30px;
  }
`;

const PageTitle = styled.h1`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 600;
  font-size: 40px;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;

  @media (max-width: 767px) {
    font-size: 32px;
  }
`;

const Subtitle = styled.h2`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 400;
  font-size: 30px;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;

  @media (max-width: 767px) {
    font-size: 24px;
  }
`;

const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const SectionTitle = styled.h3`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.blue500};
  margin: 0;

  @media (max-width: 767px) {
    font-size: 18px;
  }
`;

const BodyText = styled.p`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.blue500};
  margin: 0;

  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

const EmailLink = styled.a`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.blue500};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

const AddressText = styled.p`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.blue500};
  margin: 0;
  white-space: pre-line;

  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

const Contact = () => {
  const { data: testimonials = [] } = useTestimonials();

  return (
    <PageWrapper>
      <ContentArea>
        <ContentRow>
          <LeftContent>
            <PageTitle>Kontakt</PageTitle>
            <Subtitle>Jsme tu pro tebe.</Subtitle>

            <ContentSection>
              <SectionTitle>Potřebuješ poradit?</SectionTitle>
              <BodyText>
                Pro více informací nás můžeš kdykoliv kontaktovat na email níže. Rádi si s tebou popovídáme a vše ti vysvětlíme.
              </BodyText>
            </ContentSection>

            <ContentSection>
              <SectionTitle>Napiš email</SectionTitle>
              <EmailLink href="mailto:ahoj@trefim.to">ahoj@trefim.to</EmailLink>
            </ContentSection>

            <ContentSection>
              <SectionTitle>Adresa sídla společnosti</SectionTitle>
              <AddressText>
                DataWiz spol. s.r.o.
                {"\n"}Pařánka 2617/17 Praha 6
                {"\n"}160 00
                {"\n"}IČ: 077 64 995
                {"\n"}ID datové schránky: 5nisde3
              </AddressText>
            </ContentSection>

            <BodyText>
              Společnost je zapsána v obchodním registříku vedeném Městským soudem v Praze, oddíl C, vložka 307238
            </BodyText>
          </LeftContent>
        </ContentRow>
      </ContentArea>

      <TestimonialSection testimonials={testimonials} />
      <PartnersContainer />
    </PageWrapper>
  );
};

export default Contact;
